import React from "react";
import { Switch, Tooltip, Card, Grid } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

interface IFilterBarItemProps {
    title: string;
    UpdateFilterFlag: (filterName: string) => void;
    internalfilters: string[];
    description: string;
    filterName: string;
    displaySelected: boolean;
}

export default function FilterBarItemComponent(props: IFilterBarItemProps) {
    const [selected, setSelected] = React.useState<boolean>(props.displaySelected);

    function UpdateSelected() {
        setSelected(!selected);
        props.UpdateFilterFlag(props.filterName);
    }

    return (
        <Card style={{ marginTop: '5px', marginLeft: '5px' }}>
            <Grid container>
                <Grid size={11}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        height: '-webkit-fill-available'
                    }}>
                        <Switch checked={selected} onClick={UpdateSelected} />
                        <h4 style={{
                            marginTop: '0px',
                            marginBottom: '0px',
                            marginLeft: '10px',
                        }} >{props.title}</h4>
                    </div>
                </Grid>
                <Grid size={1}>
                    <Tooltip title={
                        <div>
                            {props.description}
                            {props.internalfilters.length > 0 &&
                                <>
                                    <br />
                                    <br />
                                    Contains the sub-filters:
                                    <ul style={{ margin: "0px" }}>
                                        {props.internalfilters.map((subfilter) =>
                                            <li key={subfilter}>{subfilter}</li>
                                        )}
                                    </ul>
                                </>}
                        </div>}>
                        <HelpOutlineIcon style={{ verticalAlign: "-webkit-baseline-middle" }} />
                    </Tooltip>
                </Grid>

            </Grid>
        </Card>
    );
}
